/** The primary tools a docked toolbar moved into its "More" menu, as a row atop the menu. */
export const toolbarOverflowRowStyles = (selector: string) => `
  ${selector} {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 36px;
  }
`;
